<script setup lang="ts">
import type { GakugeiinSearchPanelProps } from '@/types/appTypes'

const props = withDefaults(defineProps<GakugeiinSearchPanelProps>(), { loading: false })

const app = useNuxtApp()
const route = useRoute()
const storeIndex = useStoreIndex()

const prefItems = storeIndex.getPrefForSelect()
const jobcatItems = storeIndex.state.master?.job_category?.details
const jobtypeItems = storeIndex.state.master?.job_type?.details
const jobfuncItems = storeIndex.state.master?.job_carrer?.details

const refData = reactive({
  modelQuery: {
    jis_no: null,
    jobcat: [],
    jobtype: [],
    jobfunc: [],
  },
})

for (const key in props.query) {
  const queryValue = props.query[key]
  if (queryValue && key in refData.modelQuery) {
    if (Array.isArray(refData.modelQuery[key])) {
      refData.modelQuery[key] = queryValue.split(',')
    } else {
      refData.modelQuery[key] = queryValue
    }
  }
}
storeIndex.state.gakugeiinLastQuery = route.query

const onSearch = () => {
  console.log('onSearch', refData.modelQuery)

  const params = { ...refData.modelQuery }
  const notNullParam = {} as any

  for (const key in params) {
    if (!(params[key] === null || params[key] === '')) {
      if (Array.isArray(params[key])) {
        if (params[key].length) {
          notNullParam[key] = params[key].join(',')
        }
      } else {
        notNullParam[key] = params[key]
      }
    }
  }
  if ('page' in notNullParam) {
    delete notNullParam.page
  }

  if ('sort' in route.query) {
    notNullParam.sort = route.query.sort
  }

  navigateTo({
    path: '/gakugeiin',
    query: notNullParam,
  })
}
</script>

<template>
  <div class="p-searchPanel">
    <div class="p-searchPanel_panel">
      <div class="p-searchPanel_row">
        <v-select
          v-model="refData.modelQuery.jis_no"
          class="c-searchControl p-searchPanel_row_select"
          v-bind:items="prefItems"
          single-line
          hide-details
          variant="underlined"
        />
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_rowTitle">
          館種
        </div>
        <div class="c-checkGroup">
          <v-checkbox
            v-for="item in jobcatItems"
            v-bind:key="item.id"
            v-model="refData.modelQuery.jobcat"
            v-bind:label="item.text"
            v-bind:value="item.value"
            hide-details
            class="IMCustomCheckBoxNew IMCustomCheckBoxNew--ptn2 c-checkGroup_item"
          />
        </div>
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_rowTitle">
          職種
        </div>
        <div class="c-checkGroup">
          <v-checkbox
            v-for="item in jobtypeItems"
            v-bind:key="item.id"
            v-model="refData.modelQuery.jobtype"
            v-bind:label="item.text"
            v-bind:value="item.value"
            hide-details
            class="IMCustomCheckBoxNew IMCustomCheckBoxNew--ptn2 c-checkGroup_item"
          />
        </div>
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_rowTitle">
          雇用形態
        </div>
        <div class="c-checkGroup">
          <v-checkbox
            v-for="item in jobfuncItems"
            v-bind:key="item.id"
            v-model="refData.modelQuery.jobfunc"
            v-bind:label="item.text"
            v-bind:value="item.value"
            hide-details
            class="IMCustomCheckBoxNew IMCustomCheckBoxNew--ptn2 c-checkGroup_item"
          />
        </div>
      </div>
    </div>
    <div class="p-searchPanel_submit">
      <v-btn
        tile
        variant="flat"
        color="primary"
        v-bind:disabled="loading"
        v-on:click="onSearch"
      >
        <v-icon>
          mdi-magnify
        </v-icon>探す
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-searchPanel {
  margin-top: 24px;
  padding: 30px 20px;
  border-width: 1px;
  border-style: solid;
  border-color: #014da3;
  background-color: #f1f4f6;

  @include responsive.mq_down(sp) {
    padding: 10px 10px 20px;
  }

  &_panel {
    background-color: #fff;
  }

  &_row {
    padding: 10px 25px;
    border-top: 1px solid #f1f4f6;

    @include responsive.mq_down(sp) {
      padding: 10px 15px;
    }

    &_select {
      margin-top: -7px;
    }
  }

  &_rowTitle {
    margin-bottom: 5px;
    color: var(--color_text_darkgray);
    font-size: 16px;
  }

  &_submit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0 0;

    .v-btn {
      width: 200px;
      height: 48px;
    }
  }
}

.c-checkGroup {
  display: flex;
  flex-wrap: wrap;
}
</style>
